import type { ILocalizedLocalization } from '@inter-ikea-kompis/types';

/**
 *
 */
export default class LocalizedInformationAlternateLanguage {
	/**
	 * Gets the current alternate languages as an array.
	 *
	 * @param settings ...
	 * @param settings.localisation ...
	 * @param settings.localisation.alternateLanguages ...
	 * @param locale ...
	 * @returns Current language options.
	 */
	public static getAlternateLanguages(
		settings:
			| {
					localisation: { alternateLanguages: string };
			  }
			| { localization: Pick<ILocalizedLocalization, 'alternateLanguages'> },
		locale: string
	): Array<{ label: string; locale: string }> {
		if (settings) {
			const [, country] = locale.split('-');
			const alternateLanguages =
				'localisation' in settings
					? settings.localisation.alternateLanguages
					: settings.localization.alternateLanguages;
			return alternateLanguages
				.split(';')
				.reduce((accumulator: { label: string; locale: string }[], language: string) => {
					const [value, label] = language.split(':');
					if (label) {
						accumulator.push({ locale: `${value.toLowerCase()}-${country}`, label });
					}
					return accumulator;
				}, []);
		}
		return [];
	}
}
